module.exports = __webpack_public_path__ + "img/arow_up.97ba2bca.svg";